module.exports = __webpack_public_path__ + "static/media/archery.b9759afc.webp";